import now from './now.js';

export default {
  now
};



//////////////////
// WEBPACK FOOTER
// ./~/lodash-es/date.default.js
// module id = 1300
// module chunks = 0